interface AddressParts {
  addressLine?: string | null;
  postCode?: string | null;
  city?: string | null;
}

/**
 * Canonical single-line address string: "addressLine, postCode city".
 * Centralizes the format duplicated across route/stop/location displays.
 * Accepts anything address-shaped (IAddress, ILocation, timeline locations).
 */
export const formatAddressOneLine = (address?: AddressParts | null): string =>
  address
    ? `${address.addressLine}, ${address.postCode} ${address.city}`
    : "";
